interface CardContentProps {
  text: string
  username?: string
  eyebrow?: string
  title?: string
  subtitle?: string
}

export function CardContent({ text, username, eyebrow, title, subtitle }: CardContentProps) {
  const hasEditorialHierarchy = Boolean(eyebrow || title || subtitle)

  return (
    <div className={`card-content${hasEditorialHierarchy ? ' card-content-editorial' : ''}`}>
      {eyebrow ? <p className="card-editorial-eyebrow">{eyebrow}</p> : null}
      {title ? <h3 className="card-editorial-title">{title}</h3> : null}
      {subtitle ? <p className="card-editorial-subtitle">{subtitle}</p> : null}
      {text ? (
        <p className="card-text">
          {username && <><strong>{username}</strong>&nbsp;&nbsp;</>}
          {text}
        </p>
      ) : null}
    </div>
  )
}
